let animateBars = {
    bars: () => {

        // vars
        let pinkBar = ".pinkBar",
            movBar = ".movBar",
            movBar2 = ".movBar2",
            brownBar = ".brownBar",
            pinkBar2 = ".pinkBar2",
            orangeBar = ".orangeBar";

        animate(movBar, 3, -5);
        animate(pinkBar, 2, 10);
        animate(movBar2, 2, -27);
        animate(brownBar, 2, -18);
        changeColor(pinkBar2, 2, "#CD142F");

        function animate(selector, speed, x) {
            TweenMax.to(selector, speed, {
                x: x,
                repeat: -1,
                yoyo: true
            });
        }

        function changeColor(selector, speed, fill){
          TweenMax.to(selector, speed, {
            fill: fill,
            repeat: -1,
            yoyo: true
          })
        }

    }

};

$(document).ready([animateBars.bars]);
